import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.tsx';
import Countdown from './pages/Countdown.tsx';
import Setup from './pages/Setup.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/countdown" element={<Countdown />} />
        <Route path="/setup" element={<Setup />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>
);
